import { useRef } from "react"

const useEnterSearch = (handleSearch: () => void) => {
    const openMenuCountRef = useRef(0)

    return {
        inputProps: {
            onKeyDown: (e: React.KeyboardEvent) => {
                if (e.key === 'Enter' && openMenuCountRef.current === 0) handleSearch()
            }
        },
        selectProps: {
            onMenuOpen: () => { openMenuCountRef.current += 1 },
            onMenuClose: () => { openMenuCountRef.current = Math.max(0, openMenuCountRef.current - 1) },
            onKeyDown: (e: React.KeyboardEvent) => {
                if (e.key === 'Enter' && openMenuCountRef.current === 0) {
                    e.preventDefault()
                    handleSearch()
                }
            }
        }
    }
}

export default useEnterSearch
